export default "__VITE_ASSET__B2J4bIim__"